import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {LicenseAccessModuleEnableResultModal} from './license-access-module-enable.result.modal';
import {
    clearResult,
    selectLicenseAccessModuleEnableResultShown,
    selectLicenseAccessModuleEnableResultTask,
    selectLicenseAccessModuleEnableResultUuid,
} from './license-access-module-enable.slice';


export const LicenseAccessModuleEnableResult = () => (
    <BulkActionResult
        actionIdSelector={selectLicenseAccessModuleEnableResultUuid}
        actionTaskSelector={selectLicenseAccessModuleEnableResultTask}
        actionShownSelector={selectLicenseAccessModuleEnableResultShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <LicenseAccessModuleEnableResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
